import React from "react";
import styled from "styled-components";


export default styled.div`
    position: relative;
    overflow: auto;
    padding-left: 45px; 
    margin-bottom: 28px;
`;